var path = '/pages/categories/views/categories.tpl.html';
var html = "<div class=\"height-less-navbar\" ng-show=\"$state.current.data.view == 'index'\" ui-view=\"index\"></div>\n<div class=\"height-less-navbar\" ng-show=\"$state.current.data.view == 'details'\" ui-view=\"details\"></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/categories/views/categories.tpl.html
// module id = 2213
// module chunks = 1